/**
 * 会话管理服务
 * 从 AZ_AI_MVR_H5/src/services/searchConversation.ts 迁移
 */
import request from "../../utils/request";

/** 创建会话 */
export function createConversation(data: Record<string, any>) {
  return request.post("/project/conversation/create", { Entity: data }).then((r) => r.data);
}

/** 置顶会话 */
export function pinConversation(id: string) {
  return request
    .post("/project/conversation/pinnedconversation", null, { params: { id } })
    .then((r) => r.data);
}

/** 取消置顶 */
export function unpinConversation(id: string) {
  return request
    .post("/project/conversation/cancelpinnedconversation", null, { params: { id } })
    .then((r) => r.data);
}

/**
 * 首问完成后，让后端用 GPT 根据首次问答生成简短标题并更新到会话表。
 * 返回 { id, conversationTitle }；失败由后端静默回退为原标题。
 */
export function generateConversationTitle(id: string) {
  return request
    .post("/project/conversation/generatetitle", null, { params: { id } })
    .then((r) => r.data);
}

/** 修改会话标题 */
export function editConversationTitle(id: string, title: string) {
  return request
    .put("/project/conversation/edit", {
      Entity: { ID: id, ConversationTitle: title },
    })
    .then((r) => r.data);
}

/** 搜索会话列表 */
export function searchConversation(params: Record<string, any>) {
  return request.post("/project/conversation/searchconversation", params).then((r) => r.data);
}

/** 按会话标题和会话内容搜索 */
export function searchConversationContent(params: Record<string, any>) {
  return request.post("/project/conversation/searchconversationcontent", params).then((r) => r.data);
}

/** 按时间分组返回会话列表（Search Ask 空搜索时使用，每组最多 20 条） */
export function getGroupedConversations(params: Record<string, any>) {
  return request
    .post("/project/conversation/searchconversationgrouped", params)
    .then((r) => r.data);
}

/** 批量删除会话 */
export function deleteConversations(ids: string[]) {
  return request.post("/project/conversation/batchdelete", ids).then((r) => r.data);
}

/** 获取会话历史条目 */
export function getConversationHistoryItem(id: string) {
  return request.get(`/project/sessionlog/${id}`).then((r) => r.data);
}

/** 点赞 */
export function replyThumbsUp(id: string) {
  return request
    .post("/project/sessionlog/replythumbsup", null, { params: { id } })
    .then((r) => r.data);
}

/** 点踩 */
export function cancelReplyThumbsUp(id: string) {
  return request
    .post("/project/sessionlog/replyexpressdisagreement", null, { params: { id } })
    .then((r) => r.data);
}
